/**
 * D1a Task 12: platform-staff-only routes (user.is_staff). Nest it inside
 * <ProtectedRoute /> so auth has loaded before the check. is_superuser alone is not
 * enough: the platform APIs use DRF IsAdminUser, which checks is_staff only.
 */
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export default function StaffRoute() {
  const isStaff = useSelector((state) => Boolean(state.auth?.user?.is_staff));
  const location = useLocation();
  if (!isStaff) return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  return <Outlet />;
}
